<!-- Loading bar -->
<app-loading-bar />

<!-- Navigation -->
<fuse-vertical-navigation
  class="dark bg-gray-900 print:hidden"
  [appearance]="navigationAppearance"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="core.navigationItems$$()"
  [opened]="!isScreenSmall">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo -->
    <div class="flex h-20 items-center justify-center">
      <img class="w-8" src="assets/images/logo/logo.svg" alt="Logo image" />
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div
    class="flex-0 z-49 bg-card relative flex h-16 w-full items-center px-4 shadow md:px-6 dark:border-b dark:bg-transparent dark:shadow-none print:hidden">
    <div class="flex items-center space-x-2 pr-2">
      <!-- Navigation toggle button -->
      <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:bars-3'" />
      </button>
      <!-- Navigation appearance toggle button -->
      <button
        class="hidden lg:inline-flex"
        mat-icon-button
        (click)="toggleNavigationAppearance()">
        <mat-icon [svgIcon]="'heroicons_outline:arrows-right-left'" />
      </button>
    </div>
    <!-- Components -->
    <div class="ml-auto flex items-center space-x-2 pl-2">
      <!--      <languages></languages>-->
      @if (core.currentUserRole$$() === 'Admin') {
        <app-populate-all-documents-lock-indicator />
      }
      @if (core.currentUserRole$$() === 'Admin') {
        <button mat-icon-button appElasticsearchTermAnalyzerDialogTrigger>
          <mat-icon svgIcon="mat_outline:menu_book" />
        </button>
      }
      @if (core.currentUserRole$$() === 'Admin') {
        <button mat-icon-button appHelpShortcutDialogTrigger>
          <mat-icon svgIcon="mat_outline:shortcut" />
        </button>
      }
      <!--      <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>-->
      <!--      <search [appearance]="'bar'"></search>-->
      <!--      <shortcuts></shortcuts>-->
      <!--      <messages></messages>-->
      <!--      <notifications></notifications>-->
      @if (core.webColorScheme$$()) {
        <app-color-scheme-menu-button
          [webColorScheme]="core.webColorScheme$$()"
          (bySetWebColorScheme)="setWebColorScheme($event)" />
      }
      <user />
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-auto flex-col">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
    Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet />
    }
  </div>

  <!-- Footer -->
  <!--  <div-->
  <!--    class='-->
  <!--            relative-->
  <!--            flex flex-0-->
  <!--            items-center-->
  <!--            justify-start-->
  <!--            w-full-->
  <!--            h-14-->
  <!--            px-4-->
  <!--            md:px-6-->
  <!--            z-49-->
  <!--            border-t-->
  <!--            bg-card-->
  <!--            dark:bg-transparent-->
  <!--            print:hidden-->
  <!--        '-->
  <!--  >-->
  <!--    <span class='font-medium text-secondary'>Sprintapp &copy; {{ currentYear }}</span>-->
  <!--  </div>-->
</div>
